import { css, setFlexDFFDC, setProps, styled } from "theme";

type Props = {
  isArabic: boolean;
};

const isArabicLang = setProps<Props>(({ isArabic }) => isArabic)(css`
  align-items: flex-end;
`);

export const SPaymentDetailsPageContent = styled.div<Props>`
  ${setFlexDFFDC};
  ${isArabicLang};
`;
